<!--
 * @Author: LiZhiWei
 * @Date: 2026-01-27 11:36:39
 * @LastEditors: LiZhiWei
 * @LastEditTime: 2026-02-13 10:34:05
 * @Description: 
-->
<template>
  <div class="patent-row py-120px bg-#f6f8fd lt-sm:py-160px">
    <div class="landing-container lt-sm:px-32px">
      <div class="text-center mb-50px lt-sm:mb-40px">
        <h2
          class="section-title text-black pf-sc-semibold font-s-36px mb-4px sm:lh-60px lt-sm:font-s-48px"
        >
          专利技术
        </h2>
        <p class="text-main/70 pf-sc-regular font-s-18px sm:lh-30px lt-sm:font-s-26px">
          核心技术自主可控，构建坚实壁垒
        </p>
      </div>

      <div class="grid grid-cols-5 lt-sm:grid-cols-2 gap-24px lt-sm:gap-16px">
        <div
          v-for="(patent, index) in patents"
          :key="index"
          class="patent-card group relative flex flex-col items-center"
        >
          <!-- Card Frame -->
          <div
            class="relative w-full aspect-[3/4] bg-white rounded-8px overflow-hidden border border-slate-200 shadow-sm transition-all duration-300 group-hover:shadow-xl group-hover:border-blue-200 group-hover:-translate-y-2px"
          >
            <!-- Inner decorative border -->
            <div class="absolute rounded-4px z-10 pointer-events-none"></div>

            <!-- Image Container -->
            <div
              class="w-full h-full p-12px bg-slate-50 flex items-center justify-center relative overflow-hidden"
            >
              <!-- Actual Image -->
              <img
                v-if="patent.image && !patent.image.includes('placeholder')"
                :src="patent.image"
                referrerpolicy="no-referrer"
                class="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                :alt="patent.title"
                @error="handleImageError"
              />

              <!-- Hover Overlay -->
              <!-- <div
                class="absolute inset-0 bg-gradient-to-t from-slate-900/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex flex-col justify-end p-16px z-20"
              >
                <div
                  class="transform translate-y-10px group-hover:translate-y-0 transition-transform duration-300"
                >
                  <div class="text-white font-s-13px opacity-90 mb-4px tracking-wider">
                    {{ patent.id }}
                  </div>
                  <div class="flex items-center text-white/90 font-s-13px">
                    <span class="mr-4px">查看详情</span>
                    <i class="i-ep-arrow-right"></i>
                  </div>
                </div>
              </div> -->
            </div>
          </div>

          <!-- Title below card -->
          <div class="mt-16px text-center w-full px-4px">
            <h3
              class="font-s-14px lt-sm:font-s-26px pf-sc-medium text-main leading-relaxed line-clamp-2 sm:group-hover:text-primary transition-colors duration-300"
            >
              {{ patent.title }}
            </h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
  import { patents } from '@/constants/patents'

  const handleImageError = (e: Event) => {
    ;(e.target as HTMLImageElement).style.display = 'none'
  }
</script>

<style scoped>
  .patent-card {
    perspective: 1000px;
  }
</style>
